export type UseErrorTestReturn = {
  data: unknown
}

export function useErrorTest(): UseErrorTestReturn {
  return { data: null }
}
